import { AxiosError } from 'axios';
import { PUT_EDIT_RESOURCE } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface EditResourceRequest {
  fileKey: string;
  examLevel: string;
  description: string;
  title: string;
  fileName: string;
  resourceType: string;
}

export interface EditResourceResponse {}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: EditResourceResponse) => void;
  onError?: (err: AxiosError) => void;
}

export const usePutEditResource = ({ onSuccess, onError, uuid }: Input) => {
  const putEditResource = async (payload: EditResourceRequest) => {
    const res = await axiosClient.put<EditResourceResponse>(PUT_EDIT_RESOURCE(uuid), payload);
    return res.data;
  };

  return useCustomMutation(putEditResource, {
    onSuccess,
    onError,
  });
};
